import { render, staticRenderFns } from "./AdministrativeMenu.vue?vue&type=template&id=cfdb3660"
import script from "./AdministrativeMenu.vue?vue&type=script&lang=js"
export * from "./AdministrativeMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports